import { auth } from "@/firebase";
import axios from "axios";
import {getFunctionUrl} from '@/functions/functionsConfig'

// BACKEND_API
const REELS_MANAGER_ENDPOINT = getFunctionUrl('reels_manager');

// Fetch all metadata & values of the workspace
const getReelsForUser = async (
  user_id,
  workspace_id,
  filters = null,
  searchQuery = null,
  { page = null, pageSize = null, projectId = null } = {},
) => {
    try {
          let requestBody = {
            "user_id": user_id,
            "workspace_id": workspace_id,
          };

          if (searchQuery) {
            requestBody["search_query"] = searchQuery;
          }

          if (page != null) {
            requestBody.page = page;
          }
          if (pageSize != null) {
            requestBody.page_size = pageSize;
          }
          if (projectId) {
            requestBody.project_id = projectId;
          }
          
          // Transform filters to required format if present
          if (filters && Object.keys(filters).length > 0) {
            const transformedFilters = {};
            
            /* Transform time filter from:
            {
                "time": {
                    "type": "exact",
                    "data": [{ "id": "7d" }]
                }
            }
            to:
            {
                "time": "7d"
            }
            */
            if (filters.time) {
                const timeValue = filters.time.data[0].id;
                transformedFilters.time = timeValue;
            }

            /* Transform creators filter from:
            {
                "creators": {
                    "type": "any_of",
                    "data": [{ "id": "user123" }]
                }
            }
            to:
            {
                "creators": [{ "user_id": "user123" }]
            }
            */
            if (filters.creators) {
                transformedFilters.creators = filters.creators.data.map(creator => ({
                    user_id: creator.id
                }));
            }

            if (filters.projects) {
                transformedFilters.projects = filters.projects.data.map(
                    (project) => project.id,
                );
            }

            if (filters.participant_id) {
                transformedFilters.participant_id = filters.participant_id;
            }

            // Only add filters if there are any transformed filters
            if (Object.keys(transformedFilters).length > 0) {
                requestBody.filters = transformedFilters;
            }
          }
          
        //   const reelsResponse = await axios.post("http://127.0.0.1:8081/get_reels_for_user", requestBody)
        const reelsResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/get_reels_for_user`, requestBody)
        //   console.log('[debug reels]',reelsResponse)
          return { status: 'success', data : reelsResponse.data}
    } catch (error) {
          return{status:'error',error:error}
    }
  };

const getReel = async (reel_id,user_id,workspace_id) => {
try {
        let requestBody = {
        "reel_id": reel_id,
        "user_id": user_id,
        "workspace_id": workspace_id,
        };          
        const reelsResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/get_reel`, requestBody)
        // console.log('[debug reels]',reelsResponse)
        return { status: 'success', data : reelsResponse.data}
} catch (error) {
        return{status:'error',error:error}
}
};


const getReelAnon = async (reel_id) => {
    try {
            let requestBody = {
            "reel_id": reel_id,
            };          
            const reelsResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/get_reel_anon`, requestBody)
        //     console.log('[debug reels]',reelsResponse)
            return { status: 'success', data : reelsResponse.data}
    } catch (error) {
            return{status:'error',error:error}
    }
    };


const createReel = async (requestBody) => {
    try {
            const createReelResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/create_reel`, requestBody)
        //     console.log('[debug reels]',createReelResponse)
            return { status: 'success', data : createReelResponse.data}
    } catch (error) {
            return{status:'error',error:error}
    }
    };


const editReel = async (requestBody) => {
    try {
            const editReelResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/edit_reel`, requestBody)
        //     console.log('[debug reels]',editReelResponse)
            return { status: 'success', data : editReelResponse.data}
    } catch (error) {
            return{status:'error',error:error}
    }
    };

const deleteReel = async (requestBody) => {
    try {
            const deleteReelResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/delete_reel`, requestBody)
        //     console.log('[debug reels]',deleteReelResponse)
            return { status: 'success', data : deleteReelResponse.data}
    } catch (error) {
            return{status:'error',error:error}
    }
    };

const updateNoteReels = async (payload) => {
    try {        
            const reelsResponse = await axios.post(`${REELS_MANAGER_ENDPOINT}/update_note_and_reels`, payload)
        //     console.log('[debug reels]',reelsResponse)
            return { status: 'success', data : reelsResponse.data}
    } catch (error) {
            return{status:'error',error:error}
    }
    };


const downloadReel = async (payload) => {
        try {
          console.log('[debug downloadReel]', payload);
          // Make a POST request to the download_reel endpoint
          const response = await axios.post(
            `${getFunctionUrl('download_reel')}`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );
          return { status: 'success', data : response.data}
        } catch (error) {
          console.error('Error downloading reel:', error);
          return {
            status: 'error',
            message: error.response?.data?.message || 'Failed to download reel',
          };
        }
      }

export default {
    getReelsForUser,
    getReel,
    getReelAnon,
    createReel,
    editReel,
    deleteReel,
    updateNoteReels,
    downloadReel
}